import {OrgModelLinkNode} from '@q9elements/ui-kit/common';

export function formatLinkedNode(
  node: OrgModelLinkNode,
  groups: string[] = [],
  description: string = '',
  itemMxKey: any
) {
  const {
    _id,
    nodeApiName,
    nodeDescription,
    nodeObjectParent,
    objectType,
    nodeSummary,
    refModelNodes,
    linkTitle,
    type
  } = node;

  const sfNode = {
    _id,
    refModelNodes,
    type
  };

  return {
    itemMxKey,
    type: 'orgmodel',
    title: linkTitle,
    groups,
    description,
    sfNode,
    nodeDescription,
    nodeSummary,
    nodeApiName,
    nodeObjectParent,
    objectType,
    value: ''
  };
}
